"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _ModifyPackage = _interopRequireDefault(require("./ModifyPackage"));

require("../styles/_manage-subscription.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var buildPackageDescription = function buildPackageDescription(_ref) {
  var videoQuantity = _ref.videoQuantity,
      slaTurnaround = _ref.slaTurnaround;
  var descString = "".concat(videoQuantity > 1 ? videoQuantity : 'Unlimited', " Videos | ").concat(slaTurnaround, "hr");
  return _react.default.createElement("p", {
    key: descString
  }, descString);
};

var ManageSubscription = /*#__PURE__*/function (_Component) {
  _inherits(ManageSubscription, _Component);

  function ManageSubscription() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ManageSubscription);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ManageSubscription)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onImageClick", (0, _lodash.default)(function (selectedItem, onPackageSelect) {
      return function () {
        onPackageSelect(selectedItem);
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "renderItemBlock", function (item) {
      var _this$props = _this.props,
          packageData = _this$props.packageData,
          assignmentMatchField = _this$props.assignmentMatchField,
          getItemDisplayName = _this$props.getItemDisplayName,
          onPackageSelect = _this$props.onPackageSelect;
      var itemName = getItemDisplayName(item);
      var isSelected = packageData && packageData[assignmentMatchField] === item[assignmentMatchField];
      return _react.default.createElement("div", {
        className: "manage-subscription__plan-item",
        key: itemName
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)('manage-subscription__plan-item__content', {
          'manage-subscription__plan-item__content--selected': isSelected
        })
      }, _react.default.createElement(_uiKit.Image, {
        key: itemName,
        imageUrl: item.imageUrl,
        defaultImageIcon: item.iconName,
        placeholderText: item.iconName ? void 0 : itemName,
        width: "50px",
        height: "50px",
        onClick: _this.onImageClick(item, onPackageSelect),
        defaultIconBackground: isSelected ? 'horseDrawnPansy' : void 0
      }), _react.default.createElement("div", {
        className: "manage-subscription__plan-item__content__desc"
      }, _react.default.createElement("p", null, isSelected ? _react.default.createElement("strong", null, itemName) : itemName), buildPackageDescription(item))));
    });

    return _this;
  }

  _createClass(ManageSubscription, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          packages = _this$props2.packages,
          packageData = _this$props2.packageData,
          updateCustomPackage = _this$props2.updateCustomPackage,
          onModifyAddonsClick = _this$props2.onModifyAddonsClick,
          footerContent = _this$props2.footerContent;
      return !footerContent ? _react.default.createElement("div", {
        className: "manage-subscription"
      }, _react.default.createElement("div", null, _react.default.createElement("p", {
        className: "manage-subscription__block-header"
      }, "Available Plans"), _react.default.createElement("div", {
        className: "manage-subscription__plans-list"
      }, packages.map(this.renderItemBlock))), _react.default.createElement("div", {
        className: "manage-subscription__plan"
      }, _react.default.createElement("p", {
        className: "manage-subscription__block-header"
      }, "Plan Details"), _react.default.createElement(_ModifyPackage.default, {
        key: packageData.displayName,
        subPackage: packageData,
        onUpdateField: updateCustomPackage,
        onModifyAddonsClick: onModifyAddonsClick
      }))) : footerContent;
    }
  }]);

  return ManageSubscription;
}(_react.Component);

exports.default = ManageSubscription;

_defineProperty(ManageSubscription, "defaultProps", {
  packages: []
});